import {
    FETCH_DATA_ACTOR_TYPES_BY_ID_REQUEST,
    FETCH_DATA_ACTOR_TYPES_BY_ID_SUCCESS,
    FETCH_DATA_ACTOR_TYPES_BY_ID_FAILURE,
} from '../../actions/actorTypes/get-actorType-by-id-action';

const initialState = {
    actorType: null,
    isLoading: false,
    error: null,
    meta: null
};

const ActorTypeByIdReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_ACTOR_TYPES_BY_ID_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_ACTOR_TYPES_BY_ID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                actorType: action.payload,
            };

        case FETCH_DATA_ACTOR_TYPES_BY_ID_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ActorTypeByIdReducer;